export default __webpack_public_path__ + "static/media/orangeTheme-boy.b0f07491.svg";